/** Lunghezze massime che Poste Delivery accetta sulla LDV (manuale API v1.9,
 *  tabella 1). SDA ne tollera di più, ma una via di 61 caratteri ha fermato la
 *  LDV Poste del 2001785709-A (28/09): meglio saperlo guardando la scheda. */
export const LIMITI_POSTE = {
  name: 35,
  address: 40,
  postcode: 5,
  city: 30,
  province: 2,
  phone: 15,
} as const;

export type CampoIndirizzo = keyof typeof LIMITI_POSTE;
export type ValoriIndirizzo = Record<CampoIndirizzo, string>;

export const ETICHETTE_CAMPO: Record<CampoIndirizzo, string> = {
  name: "Destinatario",
  address: "Via e civico",
  postcode: "CAP",
  city: "Città",
  province: "Prov.",
  phone: "Telefono",
};

/** Caratteri contati come li conta Poste: il telefono viaggia solo con cifre e
 *  «+» (spazi e trattini li toglie il backend), il resto com'è, senza bordi. */
export function lunghezza(campo: CampoIndirizzo, valore: string): number {
  const v = valore.trim();
  return campo === "phone" ? v.replace(/[^\d+]/g, "").length : v.length;
}

export type Sforamento = { campo: CampoIndirizzo; lunghezza: number; max: number };

export function campiOltreLimite(valori: ValoriIndirizzo): Sforamento[] {
  return (Object.keys(LIMITI_POSTE) as CampoIndirizzo[])
    .map((campo) => ({
      campo,
      lunghezza: lunghezza(campo, valori[campo]),
      max: LIMITI_POSTE[campo],
    }))
    .filter((s) => s.lunghezza > s.max);
}
